import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { makeSelectIsLoading } from '../redux/selectors/loading';
import { loadAllJobFunctions } from '../redux/actions/jobFunctionActions';
import { allJobFunctionsSelector } from '../redux/selectors/jobFunctions';

const DEFAULT_JOB_FUNCTIONS = [];

const useAllJobFunctions = () => {
  const dispatch = useDispatch();
  const jobFunctions = useSelector(allJobFunctionsSelector);
  const isLoading = useSelector(makeSelectIsLoading('allJobFunctions'));

  useEffect(() => {
    if (jobFunctions === null && !isLoading) {
      dispatch(loadAllJobFunctions());
    }
  }, [jobFunctions, dispatch, isLoading]);

  return {
    jobFunctions: jobFunctions === null ? DEFAULT_JOB_FUNCTIONS : jobFunctions,
    initialized: jobFunctions !== null,
    isLoading,
  };
};

export default useAllJobFunctions;
